<template>
  <Teleport to="body">
    <cl-modal
      :close-modal-text="$t('close')"
      :visible="visible"
      size="lg"
      test-id="connection-success-modal"
      :hide-header="true"
      :hide-footer="true"
      @on-close="emit('close')"
    >
      <div class="tw-flex tw-flex-col tw-items-center">
        <div class="tw-flex tw-items-center tw-mb-6">
          <span
            class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-rounded-full tw-bg-system-success-50 tw-mr-4"
          >
            <modalSuccessIconIndex />
          </span>
          <p class="tw-text-2xl tw-font-semibold">
            {{ t("setup-complete-title") }}
          </p>
        </div>
        <p class="tw-px-12 tw-text-center tw-mb-6">
          {{ t("setup-complete-description") }}
        </p>
        <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-w-full">
          <div
            class="tw-mb-4 tw-inline-flex tw-flex-col tw-bg-white tw-p-6 tw-rounded-lg tw-border tw-border-primary-grey-100 tw-w-full"
          >
            <div class="tw-flex tw-flex-col tw-h-full">
              <div
                class="tw-border-b tw-border-b-primary-grey-200 tw-pb-4 tw-mb-4"
              >
                <TLicenceIcon class="tw-mb-4" />
                <p class="tw-text-lg tw-font-medium tw-mb-4">
                  {{ t("test-setup-title") }}
                </p>
                <p>
                  {{ t("test-setup-value") }}
                </p>
              </div>
              <div class="tw-mb-4">
                <div class="tw-flex tw-items-center tw-mb-4">
                  <span
                    class="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50 tw-mr-4"
                    >1</span
                  >
                  <p>{{ t("step-copy-test-link") }}</p>
                </div>
                <div
                  class="tw-flex tw-items-center tw-border tw-border-primary-grey-100 tw-rounded-md tw-p-2 tw-bg-primary-grey-50"
                >
                  <span
                    class="tw-flex-1 tw-min-w-0 tw-select-text tw-truncate tw-text-primary-grey-300"
                  >
                    {{ TEST_LINK }}
                  </span>
                  <t-copy-button
                    class="tw-ml-2"
                    :value="TEST_LINK"
                    :label="t('copy')"
                  />
                </div>
              </div>
              <div>
                <div class="tw-flex tw-mb-4">
                  <span
                    class="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50 tw-mr-4"
                    >2</span
                  >
                  <p v-html="t('step-send-test-email')"></p>
                </div>
              </div>
              <div>
                <div class="tw-flex tw-mb-4">
                  <span
                    class="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50 tw-mr-4"
                    >3</span
                  >
                  <p>
                    <router-link
                      :to="{
                        name: 'customer-email_security-email-history',
                        params: { orgUuid: route.params.orgUuid },
                      }"
                      class="tw-underline"
                    >
                      {{ t("step-go-to-email-history-a") }}
                    </router-link>
                    <span>
                      {{ t("step-go-to-email-history-b") }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="tw-bg-primary-cobalt-blue-25 tw-p-4 tw-rounded-xl">
                <p class="tw-text-sm" v-html="t('test-setup-note')"></p>
              </div>
            </div>
          </div>
          <div
            class="tw-mb-4 tw-inline-flex tw-flex-col tw-bg-white tw-p-6 tw-rounded-lg tw-border tw-border-primary-grey-100 tw-w-full"
          >
            <outlook-add-in-card-index />
          </div>
        </div>
      </div>
    </cl-modal>
  </Teleport>
</template>

<script setup lang="ts">
import TLicenceIcon from "@/components/TLicenceIcon/TLicenceIcon.vue";
import TCopyButton from "@/components/TCopyButton/TCopyButton.vue";
import modalSuccessIconIndex from "./modal-success-icon/modal-success-icon.index.vue";
import outlookAddInCardIndex from "../outlook-add-in-card/outlook-add-in-card.index.vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

defineProps<{ visible: boolean }>();
const emit = defineEmits<{ close: [] }>();
const { t } = useI18n();
const route = useRoute();

const TEST_LINK = "http://phishingsite.net/";
</script>
